module.exports = __webpack_public_path__ + "img/Icon12_08.9c553890.svg";